module.exports = __webpack_public_path__ + "static/media/media7.8009aaf0.jpg";